import { Space, Button, App } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import { deleteMenuItem } from "@/api/definitionsMenu";

const ViewFile = ({ uuid, name, onChange }) => {
  const { message } = App.useApp();

  const handleDelete = async () => {
    try {
      await deleteMenuItem({ uuid });
      await onChange();
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    }
  };

  return (
    <>
      <Space>
        {name}
        <div>
          <Button
            size="small"
            type="link"
            icon={<DeleteOutlined />}
            onClick={handleDelete}
          />
        </div>
      </Space>
    </>
  );
};

export default ViewFile;
